import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">视频分类</h2>
          <Link to="/category/dianying" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2.5 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100/70 group-hover:bg-primary-200/70 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-600 group-hover:text-primary-700`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count.toLocaleString()}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}